import React, { Component, Fragment } from 'react'
import * as R from 'ramda'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import Input from '../form/Input'
import Select from '../form/Select'
import { download } from '../../utils/helpers'

const DEFAULT_CURRENCIES = ['USD']
@observer
class WidgetContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            menuOpen: false,
        }
    }

    componentWillUnmount() {
        document.body.removeEventListener('click', this.toggleMenuOpen)
    }

    toggleV3WidgetEditor = () => {
        const { chartKey, toggleV3WidgetEdit } = this.props
        toggleV3WidgetEdit(chartKey)
    }

    toggleMenuOpen = (e) => {
        e.stopPropagation()
        const { menuOpen } = this.state

        if (!menuOpen) document.body.addEventListener('click', this.toggleMenuOpen)
        if (menuOpen) document.body.removeEventListener('click', this.toggleMenuOpen)

        this.setState({ menuOpen: !menuOpen })
    }

    downloadPng = () => {
        const { title } = this.props
        const echartInstance = this.chartRef.getEchartsInstance()
        const base64 = echartInstance.getDataURL({ type: 'png', backgroundColor: '#FFF' })
        download(base64, `${title}.png`)
    }

    renderMenu = () => {
        const { menuOpen } = this.state
        const {
            removeChart, chartKey, preview, DynamicDashboardStore, chartType,
        } = this.props
        const { appStore, editing } = DynamicDashboardStore
        const { userData, isExploriAdmin } = appStore
        const { role } = userData
        const isDirectorReport = [170, 150].includes(role)
        if (preview) return null
        const enableDownload = !['text', 'multiText', 'lmx'].includes(chartType)
        return (
            <div
                className="menu"
                style={{
                    marginRight: '8px',
                    cursor: 'pointer',
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                <div
                    onClick={this.toggleMenuOpen}
                    style={{
                        border: '1px solid #EDF1F7',
                        height: '32px',
                        width: '32px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: '4px',
                        backgroundColor: menuOpen ? '#EDF1F7' : undefined,
                    }}
                >
                    <i className="fa-solid fa-ellipsis-vertical" style={{ fontSize: '14px' }} />
                </div>
                <div style={{
                    position: 'absolute',
                    width: '200px',
                    height: 'fit-content',
                    top: '35px',
                    left: '-168px',
                    display: menuOpen ? 'block' : 'none',
                    background: 'white',
                    boxShadow: '2px 2px 26px #102E4A26',
                    borderRadius: '6px',
                    cursor: 'default',
                    zIndex: '5000',
                }}
                >
                    <ul style={{
                        listStyleType: 'none', fontSize: '13px', cursor: 'pointer', height: '100%', position: 'relative', padding: '0',
                    }}
                    >
                        {!isDirectorReport && editing
                            ? (
                                <li onClick={this.toggleV3WidgetEditor} style={{ padding: '10px 0 10px 32px' }}>
                                    <i className="fa-light fa-clone" style={{ marginRight: '5px' }} />
                                    {i18n.t('dashboards.widgetMenu.editWidget')}
                                    {' '}
                                    - New v3
                                </li>
                            )
                            : null }
                        {enableDownload
                            ? (
                                <li onClick={this.downloadPng} style={{ padding: '10px 0 10px 32px' }}>
                                    <i className="fa-light fa-clone" style={{ marginRight: '5px' }} />
                                    {i18n.t('dashboards.widgetMenu.downloadWidget')}
                                </li>
                            )
                            : null}
                        {!isDirectorReport && editing
                            ? (
                                <li
                                    onClick={() => removeChart(chartKey)}
                                    style={{
                                        padding: '10px 0 10px 32px', color: '#D9314B', backgroundColor: '#FAFBFC', width: '100%',
                                    }}
                                >
                                    <i className="fas fa-times" style={{ marginRight: '5px' }} />
                                    {i18n.t('dashboards.widgetMenu.removeWidget')}
                                </li>
                            )
                            : null }
                    </ul>
                </div>
            </div>
        )
    }

    changeCurrency = (currency) => {
        const { DynamicDashboardStore, widget } = this.props
        const { updateWidget } = DynamicDashboardStore
        const newWidget = {
            ...widget,
            widgetRenderSettings: { ...widget.widgetRenderSettings, currency },
        }
        const widgets = R.pathOr([{}], ['widgets'], DynamicDashboardStore)
        const widgetIndex = widgets.findIndex((w) => w.key === newWidget.key)
        updateWidget(widgetIndex, newWidget)
    }

    getCurrencyOptions = () => {
        const defaultCurrencies = DEFAULT_CURRENCIES
        const { DynamicDashboardStore } = this.props
        const { appStore } = DynamicDashboardStore
        const fetchedCurrencies = appStore.client.currencies

        const currencies = fetchedCurrencies.length > 0
            ? fetchedCurrencies
            : defaultCurrencies

        return currencies.map((c) => ({ label: c, value: c }))
    }

    renderCurrencySelector = () => {
        const { widget } = this.props

        const renderCurrency = R.pathOr(
            widget.isCurrency ? 'currency' : false,
            ['widgetRenderSettings', 'format'],
            widget,
        ) === 'currency'

        if (!renderCurrency) return null

        return (
            <div style={{ width: '100px', marginRight: '5px' }}>
                <Select
                    classNamePrefix="dropdown"
                    className="exploriDropdown"
                    name="currency"
                    options={this.getCurrencyOptions()}
                    defaultValue={R.pathOr(
                        'USD',
                        ['widgetRenderSettings', 'currency'],
                        widget,
                    )}
                    onBlur={({ value }) => { this.changeCurrency(value) }}
                    blurOnClear
                />
            </div>
        )
    }

    render() {
        const {
            title,
            chart,
            renderChart,
            removeChart,
            chartKey,
            preview,
            scrollable,
            chartType,
            changeTitle,
            DynamicDashboardStore,
        } = this.props

        const { editing } = DynamicDashboardStore
        const scrollableType = ['stackedBar', 'bar'].includes(chartType) ? 'scrollableY' : 'scrollableX'
        const lmxCompact = renderChart < 800 && chartType === 'lmx'
        const setRef = ['text', 'multiText', 'lmx'].includes(chartType) ? undefined : (e) => { this.chartRef = e }
        let chartComponent
        if (chartType !== 'quadrantAnalysis') {
            chartComponent = lmxCompact
                ? React.cloneElement(chart, { compact: true, setRef, preview })
                : React.cloneElement(chart, { setRef, preview })
        } else if (chart.props.children[1].props.children === 'No data has been found') {
            chartComponent = React.cloneElement(chart, { setRef })
        } else {
            chartComponent = React.cloneElement(
                chart,
                {
                    children: [
                        chart.props.children[0],
                        React.cloneElement(
                            chart.props.children[1],
                            {
                                children: [
                                    React.cloneElement(
                                        chart.props.children[1].props.children,
                                        { setRef },
                                    ),
                                ],
                            },
                        ),
                    ],
                },
            )
        }

        return (
            <Fragment>
                <div className={`widgetContainer ${scrollable ? scrollableType : ''} ${editing ? 'editing' : ''}`}>
                    <div className="heading" style={{ display: 'flex', alignItems: 'center' }}>
                        {preview
                            ? (
                                <Input
                                    style={{ width: '100%', marginRight: '10px', marginTop: '8px' }}
                                    defaultValue={title}
                                    onChange={changeTitle}
                                />
                            )
                            : title}
                        <div style={{ display: 'flex' }}>
                            {!preview ? this.renderCurrencySelector() : null}
                            {this.renderMenu()}
                            {preview && removeChart
                                ? <i onClick={() => removeChart(chartKey)} className="fas fa-times" style={{ marginRight: '10px' }} />
                                : null }
                        </div>
                    </div>
                    <div className="widget">
                        {renderChart ? chartComponent : null}
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default WidgetContainer
